import { REGISTER_SUCCESS, REGISTER_FAILURE, REGISTER_RESET } from '../actions/AuthActions';

const initialState = {
    registerSuccess: false,
    feedbackMessage: null,
    error: null
}

export default function registerReducer(state = initialState, action) {

    switch (action.type) {
        case REGISTER_SUCCESS:
            return {
                registerSuccess: true,
                feedbackMessage: 'Cererea de creare a contului a fost trimisă cu succes!',
                error: null
            };

        case REGISTER_FAILURE:
            return {
                registerSuccess: false,
                feedbackMessage: action.payload.error,
                error: action.payload.error
            };
        case REGISTER_RESET:
            return {
                registerSuccess: false,
                feedbackMessage: null,
                error: null
            }
        default:
            return state;
    }
}